'use strict';

import './assets/icon.ico';

var Vue = require('vue');
var VueResource = require('vue-resource');

Vue.use(VueResource);
Vue.http.options.emulateJSON = true;

import iView from 'iview';
Vue.use(iView);

var VueI18n = require('vue-i18n');
Vue.use(VueI18n);

import zhLocale from './lang/zh-CN';
// import zhLocale from 'iview/src/locale/lang/zh-CN';
Vue.config.lang = 'zh-CN';
Vue.locale('zh-CN', zhLocale);

import router from './router';

router.beforeEach((transition) => {
  iView.LoadingBar.start();
  transition.next();
});

router.afterEach(() => {
  iView.LoadingBar.finish();
});

import { Swipe, SwipeItem } from 'vue-swipe';
Vue.component('swipe', Swipe);
Vue.component('swipe-item', SwipeItem);

import store from './vuex/store';
import Socket from './socket';
Vue.use(
  Socket,
  'https://alumni.umiuni.com',
  store,
);

Vue.use(require('vue-script2'));

Vue.directive('auto-bottom', {
  deep: true,
  update: function () {
    this.el.scrollTop = this.el.scrollHeight;
  },
});

import App from './App.vue';
router.start(App, 'app');



// WEBPACK FOOTER //
// ./src/main.js